import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { resultFilesApi } from "../api/resultFiles";

const overviewKey = (orderId: string) => ["order-result-files", orderId];

export function useOrderResultFiles(orderId: string | null | undefined) {
  return useQuery({
    queryKey: overviewKey(orderId ?? ""),
    queryFn: () => resultFilesApi.overview(orderId as string),
    enabled: !!orderId,
  });
}

export function useUploadResultFiles(orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lineItemId, files }: { lineItemId: string; files: File[] }) =>
      resultFilesApi.upload(lineItemId, files),
    onSuccess: () => qc.invalidateQueries({ queryKey: overviewKey(orderId) }),
  });
}

export function useAcceptResultFile(orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => resultFilesApi.accept(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: overviewKey(orderId) }),
  });
}

export function useRejectResultFile(orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, comment }: { id: string; comment: string }) =>
      resultFilesApi.reject(id, comment),
    onSuccess: () => qc.invalidateQueries({ queryKey: overviewKey(orderId) }),
  });
}

export function useDeleteResultFile(orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => resultFilesApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: overviewKey(orderId) }),
  });
}
